import React, { lazy } from 'react';
import { overviewColumns } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));

const Overview = ({ list, i18n }) => {
  const generateRows = () => {
    return list.map((ele) => {
      const { green = 0, yellow = 0, red = 0 } = ele.severity || {};

      const leftCurve = green ? 'green' : yellow ? 'yellow' : 'red';
      const rightCurve = red ? 'red' : yellow ? 'yellow' : 'green';

      ele.severityGraph = (
        <div className="severity-wrapper">
          <div
            style={{ width: `${green || 0}%` }}
            className={`green-wrapper ${leftCurve === 'green' ? 'leftCurve addBorder' : ''} ${
              rightCurve === 'green' ? 'rightCurve' : ''
            }`}
          ></div>
          <div
            style={{ width: `${yellow || 0}%` }}
            className={`yellow-wrapper ${yellow ? 'addBorder' : ''} ${leftCurve === 'yellow' ? 'leftCurve' : ''} ${
              rightCurve === 'yellow' ? 'rightCurve' : ''
            }`}
          ></div>
          <div
            style={{ width: `${red || 0}%` }}
            className={`red-wrapper ${leftCurve === 'red' ? 'leftCurve' : ''} ${rightCurve === 'red' ? 'rightCurve' : ''}`}
          ></div>
        </div>
      );

      if (!ele.severity) {
        ele.severityGraph = (
          <div className="severity-wrapper">
            <div className="green-wrapper leftCurve addBorder rightCurve" style={{ width: `100%` }}></div>
          </div>
        );
      }

      return ele;
    });
  };

  return (
    <>
      <Table
        type="client"
        defaultSortBy={{ sortBy: 'date', order: 'desc' }}
        title=""
        columns={overviewColumns}
        data={generateRows()}
        emptyMessage={i18n.t('common.tableEmptyMessage')}
        itemsPerPage={10}
        id="dashBoardAlerts"
        noPagination
        actions={[]}
        i18n={i18n}
      />
    </>
  );
};

export default Overview;

Overview.defaultProps = {};
